import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { Butterfly, LivonMark } from "./Brand";

export const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-livon-ink text-livon-bg overflow-hidden">
      <div className="absolute inset-0 opacity-30 pointer-events-none">
        <div className="blob blob-lg" style={{ background: "radial-gradient(circle, rgba(159,148,194,0.6) 0%, transparent 70%)", top: "10%", left: "-10%" }} />
        <div className="blob blob-lg" style={{ background: "radial-gradient(circle, rgba(159,193,213,0.5) 0%, transparent 70%)", bottom: "-10%", right: "-10%" }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-28 md:pt-36 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
            <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-white border border-white/20">
              <Butterfly size={32} />
            </span>
            <LivonMark className="serif text-3xl tracking-[0.16em]" supSize="0.4em" />
          </div>
            <p className="serif italic text-livon-bg/75 mt-2 text-xl md:text-2xl leading-snug max-w-md">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-[11px] tracking-[0.3em] uppercase text-livon-bg/50 mb-5">{t.footer.sections.product}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="https://method.livon.se" target="_blank" rel="noreferrer" className="hover:text-livon-bg text-livon-bg/80 transition-colors" data-testid="footer-method">{t.footer.links.method}</a></li>
              <li><a href="https://app.livon.se" target="_blank" rel="noreferrer" className="hover:text-livon-bg text-livon-bg/80 transition-colors" data-testid="footer-app">{t.footer.links.app}</a></li>
              <li><a href="https://academy.livon.se" target="_blank" rel="noreferrer" className="hover:text-livon-bg text-livon-bg/80 transition-colors" data-testid="footer-education">{t.footer.links.education}</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-[11px] tracking-[0.3em] uppercase text-livon-bg/50 mb-5">{t.footer.sections.company}</div>
            <ul className="space-y-3 text-sm">
              <li><a href="#about" className="hover:text-livon-bg text-livon-bg/80 transition-colors" data-testid="footer-about">{t.footer.links.about}</a></li>
              <li><a href="mailto:support@livon.se" className="hover:text-livon-bg text-livon-bg/80 transition-colors" data-testid="footer-contact">{t.footer.links.contact} — support@livon.se</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-20 md:mt-28 pt-8 border-t border-livon-bg/15 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-livon-bg/55 tracking-wide">
          <div>{year} {t.footer.copyright}</div>
          <div className="tracking-[0.25em] uppercase">livon.se · method.livon.se · app.livon.se · academy.livon.se</div>
        </div>

        <div className="serif select-none leading-none mt-16 text-livon-bg/10 font-light flex items-start" style={{ fontSize: "clamp(5rem, 22vw, 22rem)", letterSpacing: "0.04em" }}>
          <LivonMark supSize="0.12em" />
        </div>
      </div>
    </footer>
  );
};
